import * as React from "react";
import { Button} from "antd";
import { connect } from "react-redux";
//import { CopyToClipboard } from "react-copy-to-clipboard";



interface IEorderProps {
  skuName:any;
  contact:any;
  taoAccount:any;
}


class Eorder extends React.Component<IEorderProps, any> {
  state = {
    data:'',
  };
  constructor(props: IEorderProps) {
    super(props);
  }

  show = () => {
    window.open("mailto:chanmao@lanmao.cn?subject=LM +"+this.props.skuName+" +"+this.props.taoAccount+" +"+this.props.contact);
  }

  render() {
    return (
      <React.Fragment>
      <Button onClick={this.show}>邮件下单</Button> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  email: state.orderDetails.email,
  skuName: state.orderDetails.skuName,
  contact: state.orderDetails.contact,
  taoAccount: state.orderDetails.taoAccount,
});

const mapDispatch = dispatch => {
  return {
  };
};

export default connect(
  mapState,
  mapDispatch
)(Eorder);
